module.exports = __webpack_public_path__ + "img/but_lobby_gift.cab18d9f.png";